export const Tools = [
  {
    CategoryName: "JSON Tools",
    SubCategory: [
      { SubCategory: "JSON Formatter", Icon: "/FileCodeRaw.svg", Description: "Minify and beautify JSON" },
      { SubCategory: "JSON Validator", Icon: "/Bracketsblue.svg", Description: "Validate JSON syntax" },
      { SubCategory: "JSON Converters", Icon: "/ArrowsLeftRightRaw.svg", Description: "Convert JSON to YAML, CSV, XML, and query parameters" },
      { SubCategory: "JSON Structure Analyzer", Icon: "/TreeStructureRaw.svg", Description: "Analyse JSON structure, paths, and stats" }
    ],
    Icon: "/JSONTools.svg"
  },
  {
    CategoryName: "Data Format / Markup Tools",
    SubCategory: [
      { SubCategory: "XML Formatter", Icon: "/hash.svg", Description: "Format, beautify, and validate XML data" },
      { SubCategory: "HTML Formatter", Icon: "/hash.svg", Description: "Beautify and organize HTML code" },
      { SubCategory: "HTML Tag Remover", Icon: "/hash.svg", Description: "Remove HTML tags and extract plain text" },
      { SubCategory: "Markdown to HTML", Icon: "/hash.svg", Description: "Convert Markdown content into HTML" }
    ],
    Icon: "/connect.svg"
  },
  {
    CategoryName: "API & Diagram Tools",
    SubCategory: [
      { SubCategory: "APILens", Icon: "/hash.svg", Description: "Design, explore and test APIs in one workspace." },
      { SubCategory: "Flowlens", Icon: "/hash.svg", Description: "Design, visualize and share diagrams in one workspace." }
    ],
    Icon: "/pen-tool.svg"
  },
  {
    CategoryName: "Encoder / Decoder",
    SubCategory: [
      { SubCategory: "Base64 Encoder/Decoder", Icon: "/binary.svg", Description: "Encode and decode Base64 text" },
      { SubCategory: "Base64URL Encoder/Decoder", Icon: "/link.svg", Description: "Encode Base64 data for safe URLs" },
      { SubCategory: "URL Encoder/Decoder", Icon: "/link.svg", Description: "Convert text to URL-safe format" },
      { SubCategory: "HTML Entity Encoder/Decoder", Icon: "/brackets-angle.svg", Description: "Encode and decode HTML entities" },
      { SubCategory: "Hex Encoder/Decoder", Icon: "/hash.svg", Description: "Convert text to hexadecimal and back" },
      { SubCategory: "Quoted-Printable Encoder/Decoder", Icon: "/file-text.svg", Description: "Encode or decode email-safe text" },
      { SubCategory: "ASCII Bytes Converter", Icon: "/binary.svg", Description: "Convert ASCII text to byte values" }
    ],
    Icon: "/binary.svg"
  },
  {
    CategoryName: "Text Utilities",
    SubCategory: [
      { SubCategory: "Case Converter", Icon: "/hash.svg", Description: "Convert text between common case styles" },
      { SubCategory: "Text Counter", Icon: "/hash.svg", Description: "Count characters, words, lines, and spaces" },
      { SubCategory: "Escape/Unescape", Icon: "/hash.svg", Description: "Escape or unescape special characters" },
      { SubCategory: "Whitespace Cleaner", Icon: "/hash.svg", Description: "Remove extra spaces and collapse whitespace" },
      { SubCategory: "Find & Replace", Icon: "/hash.svg", Description: "Search for text and replace it instantly" },
      { SubCategory: "Regex Tester", Icon: "/hash.svg", Description: "Test, validate, and debug regular expressions" },
      { SubCategory: "Lorem Ipsum Generator", Icon: "/hash.svg", Description: "Generate placeholder Lorem Ipsum text" },
      { SubCategory: "Random String Generator", Icon: "/hash.svg", Description: "Create random strings with custom length" }
    ],
    Icon: "/Text.svg"
  },
  {
    CategoryName: "Identifier / Value Generators",
    SubCategory: [
      { SubCategory: "UUID Generator", Icon: "/hash.svg", Description: "Generate unique UUID identifiers" },
      { SubCategory: "Color Picker", Icon: "/hash.svg", Description: "Pick colors and get HEX, RGB, and HSL values" }
    ],
    Icon: "/wrench.svg"
  },
  {
    CategoryName: "Diff Tools",
    SubCategory: [
      { SubCategory: "Text Diff", Icon: "/hash.svg", Description: "Compare text and highlight differences" },
      { SubCategory: "CSV Diff", Icon: "/hash.svg", Description: "Compare CSV files and datasets" },
      { SubCategory: "XML Diff", Icon: "/hash.svg", Description: "Compare XML structures and changed nodes" },
      { SubCategory: "JSON Diff", Icon: "/GitDiffRaw.svg", Description: "Compare JSON objects and highlight differences" }
    ],
    Icon: "/gates.svg"
  },
  {
    CategoryName: "Crypto & Security",
    SubCategory: [
      { SubCategory: "Hash Generator", Icon: "/hash.svg", Description: "Generate SHA hashes for text" },
      { SubCategory: "HMAC Calculator", Icon: "/lock.svg", Description: "Generate and verify HMAC values" },
      { SubCategory: "Argon2 Hasher", Icon: "/hash.svg", Description: "Generate Argon2 password hashes" },
      { SubCategory: "BCrypt Hasher", Icon: "/lock.svg", Description: "Generate BCrypt password hashes" },
      { SubCategory: "JWT Decoder/Encoder", Icon: "/lock.svg", Description: "Create, decode, and inspect JWT tokens" }
    ],
    Icon: "/lock.svg"
  },
  {
    CategoryName: "Database Tools",
    SubCategory: [
      { SubCategory: "JSON to SQL", Icon: "/hash.svg", Description: "Convert JSON data into SQL insert scripts" },
      { SubCategory: "CSV to SQL", Icon: "/hash.svg", Description: "Transform CSV files into SQL insert scripts" }
    ],
    Icon: "/database.svg"
  },
  {
    CategoryName: "Time & Date",
    SubCategory: [
      { SubCategory: "Cron Parser & Generator", Icon: "/hash.svg", Description: "Parse and build cron expressions" },
      { SubCategory: "Time Zone Converter", Icon: "/hash.svg", Description: "Convert times across time zones" },
      { SubCategory: "Time Difference Calculator", Icon: "/hash.svg", Description: "Calculate duration between dates or times" },
      { SubCategory: "Timestamp Converter", Icon: "/hash.svg", Description: "Convert timestamps to readable dates and back" }
    ],
    Icon: "/clock.svg"
  },
  {
    CategoryName: "Image Tools",
    SubCategory: [
      { SubCategory: "Image Converter", Icon: "/hash.svg", Description: "Convert JPG, PNG, and TIFF images" },
      { SubCategory: "Base64 Image Converter", Icon: "/hash.svg", Description: "Encode images to Base64 and decode them back" }
    ],
    Icon: "/image.svg"
  },
  {
    CategoryName: "Document Tools",
    SubCategory: [
      { SubCategory: "PDF Image Converter", Icon: "/hash.svg", Description: "Convert PDFs and images" },
      { SubCategory: "PDF Merger & Splitter", Icon: "/hash.svg", Description: "Merge multiple PDFs or split a PDF" },
      { SubCategory: "DOCX to PDF", Icon: "/hash.svg", Description: "Convert Word documents to PDF" },
      { SubCategory: "DOCX to Markdown", Icon: "/hash.svg", Description: "Convert Word documents to Markdown" }
    ],
    Icon: "/file-text.svg"
  }
]


export const ExampleJSON = {
  "project_id": "ABC-123",
  "project_name": "Nebula",
  "is_internal": true,
  "owner": {
    "name": "Alex Rivera",
    "email": "alex@company.com"
  },
  "milestones": [
    "Design",
    "Alpha",
    "Beta"
  ],
  "current_task": {
    "id": 505,
    "status": "In Progress",
    "priority": 1,
    "tags": [
      "frontend",
      "ui-fix"
    ]
  },
  "deadline": "2026-12-31",
  "budget_utilization": 0.65
}

export const ExampleJSONforCSV = {
  "users": [
    { "name": "Alice", "email": "alice@example.com", "age": 30 },
    { "name": "Bob", "email": "bob@example.com", "age": 25 },
    { "name": "Charlie", "email": "charlie@example.com", "age": 35 }
  ]
}

export const ExampleMinifiedJSON = {"project_id":"ABC-1267","project_name":"Nebula","is_internal":true,"owner":{"name":"Alex Rivera","email":"alex@company.com"},"milestones":["Design","Alpha","Beta"],"current_task":{"id":505,"status":"In Progress","priority":1,"tags":["frontend","ui-fix"]},"deadline":"2026-12-31","budget_utilization":0.65};
export const csv = `id,name,age,city
1,John Doe,30,New York
2,Jane Smith,25,Los Angeles
3,Bob Johnson,40,Chicago
4,Alice Williams,35,Houston
5,Charlie Brown,28,Phoenix`;

export const exampleXML = `<root>
<name>COBYGO</name>
<address>
<city>Chennai</city>
<zip>600100</zip>
</address>
</root>`;

export const MinifiedXML = `<root><name>COBYGO</name><address><city>Chennai</city><zip>600100</zip></address></root>`;

export const MinifiedHTMLExample = `<html><body><h1>Hello</h1></body></html>`;
export const exampleHTML =    `<!DOCTYPE html>
<html lang="en">
<head>
    <title>Minimal Page</title>
</head>
<body>
    <h1>Hello World</h1>
    <p>This is a 10-line HTML sample.</p>
</body>
</html>`;

export const markDownExapmple= `# Title\n\n- One\n- Two`;
export const exampleQP = `name=John%20Doe&age=30&city=New%20York`
export const exampleYAML = `name: John Doe
age: 30
is_active: true
salary: 75000.50`;

export const convertors =["JSON", "CSV", "XML", "QP", "YAML"];
export const exampleJSONforEvaluator = {
  "store": {
    "name": "DevGround Store",
    "location": {
      "city": "Chennai",
      "zip": "600001"
    },
    "books": [
      {
        "title": "Java Basics",
        "price": 10,
        "inStock": true,
        "category": "programming"
      },
      {
        "title": "Spring Boot Pro",
        "price": 15,
        "inStock": false,
        "category": "programming"
      },
      {
        "title": "Clean Code",
        "price": 8.99,
        "inStock": true,
        "category": "software"
      }
    ]
  }
}

export const exampleParagraph = "A paragraph is a fundamental unit of writing that organizes and develops a single, distinct idea. It acts as a structural stepping stone for readers by grouping related sentences together and separating different thoughts to improve readability. Typically, a well-formed paragraph begins with a topic sentence that declares the main point, followed by supporting details, facts, or explanations, and finishes with a concluding sentence that bridges to the next concept. By breaking large blocks of text into these logical chunks, paragraphs prevent reader fatigue and ensure that arguments or stories flow smoothly from start to finish."

export const cheatsheet = [
  { Experssion:"Root", Description:"Represents the entire JSON document." , Example:"$" ,Output:"{\"store\": { ... } }" },
  { Experssion:"Access Property (Dot Notation)", Description:"Access a property using dot notation." , Example:"$.store.name" ,Output:"\"DevGround Store\"" },
  { Experssion:"Nested Property", Description:"Access deeply nested values." , Example:"$.store.location.city" ,Output:"\"Chennai\"" },
  { Experssion:"Bracket Notation", Description:"Access properties using string keys. Required when:\n•	key has spaces\n•	key has special characters" , Example:"$['store']['name']" ,Output:"\"Cobygo\"" },
  { Experssion:"Array Index", Description:"Access element by index." , Example:"$.store.books[0]" ,Output:"{\n\"title\": \"Java Basics\",\n\"price\": 10\n}" },
  { Experssion:"Last Element", Description:"Access last item in array." , Example:"$.store.books[-1]" ,Output:"{\n\"title\": \"Clean Code\",\n\"price\": 8.99\n}\"" },
  { Experssion:"Array Slice", Description:"Returns elements from index 0 to 1" , Example:"$.store.books[0:2]" ,Output:"[\n{ \"title\": \"Java Basics\" },\n{ \"title\": \"Spring Boot Pro\" }\n]" },
  { Experssion:"Wildcard (All Elements)", Description:"Returns all elements in array." , Example:"$.store.books[*]" ,Output:"[\n{ ... },\n{ ... },\n{ ... }\n]" },
  { Experssion:"Wildcard (All Properties)", Description:"Returns all child properties." , Example:"$.store.*" ,Output:"[\n\"DevGround Store\",\n{ \"city\": \"Chennai\", \"zip\": \"600001\" },\n[ ...books ]\n]" },
  { Experssion:"Recursive Descent", Description:"Find all title fields anywhere" , Example:"$..title" ,Output:"[\n\"Java Basics\",\n\"Spring Boot Pro\",\n\"Clean Code\"\n]" },
  { Experssion:"Property of Each Element", Description:"Extract specific field from all elements." , Example:"$.store.books[*].title" ,Output:"[\n\"Java Basics\", \n\"Spring Boot Pro\", \n\"Clean Code\"\n]" },
  { Experssion:"Equals", Description:"Filter objects where condition matches." , Example:"$.store.books[?(@.inStock == true)]" ,Output:"[\n{\n\"title\": \"Java Basics\",\n\"inStock\": true\n},\n{\n\"title\": \"Clean Code\",\n\"inStock\": true\n}\n]" },
  { Experssion:"Greater Than", Description:"Returns the value greater than the input" , Example:"$.store.books[?(@.price > 10)]" ,Output:"[\n{ \"title\": \"Spring Boot Pro\" }\n]" },
  { Experssion:"Less Than or Equal", Description:"Returns the value less then or equal to the input" , Example:"$.store.books[?(@.price <= 10)]" ,Output:"[\n{\n\"title\": \"Java Basics\",\n\"price\": 10\n},\n{\n\"title\": \"Clean Code\",\n\"price\": 8.99\n}\n]" },
  { Experssion:"Not Equal", Description:"Returns the values npt equal to the input" , Example:"$.store.books[?(@.price != 8.99)]" ,Output:"[\n{ \"title\": \"Java Basics\" },\n{ \"title\": \"Spring Boot Pro\" }\n]" },
  { Experssion:"AND Condition", Description:"Returns the vlaue of all the conditions shoud pass" , Example:"$.store.books[?(@.price > 5 && @.inStock == true)]" ,Output:"[\n{ \"title\": \"Java Basics\" },\n{ \"title\": \"Clean Code\" }\n]" },
  { Experssion:"OR Condition", Description:"Returns the value that satisfies any of the condition" , Example:"$.store.books[?(@.price < 9 || @.inStock == false)]" ,Output:"[\n{ \"title\": \"Spring Boot Pro\" },\n{ \"title\": \"Clean Code\" }\n]" },
  { Experssion:"Exists Check", Description:"Checks if field exists." , Example:"$.store.books[?(@.category)]" ,Output:"" },
  { Experssion:"Checks if field exists.", Description:"Match using regex." , Example:"$.store.books[?(@.title =~ /Java.*/)]" ,Output:"[\n{ \"title\": \"Java Basics\" }\n]" }
]


export const SampleJWT = [{algorithm:"HS256",value:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c"},
  {algorithm:"RS256",value:"eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjFlOWdkazcifQ.ewogImlzcyI6ICJodHRwOi8vc2VydmVyLmV4YW1wbGUuY29tIiwKICJzdWIiOiAiMjQ4Mjg5NzYxMDAxIiwKICJhdWQiOiAiczZCaGRSa3F0MyIsCiAibm9uY2UiOiAibi0wUzZfV3pBMk1qIiwKICJleHAiOiAxMzExMjgxOTcwLAogImlhdCI6IDEzMTEyODA5NzAsCiAiY19oYXNoIjogIkxEa3RLZG9RYWszUGswY25YeENsdEEiCn0.c2FtcGxlLXJzMjU2LXNpZ25hdHVyZQ"},
  {algorithm:"ES256",value:"eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImVjLWtleS0wMSJ9.eyJpc3MiOiJodHRwczovL2F1dGguZXhhbXBsZS5jb20iLCJzdWIiOiJ1c3JfMGg3eDUyYmsiLCJhdWQiOiJteS1hcHAiLCJpYXQiOjE3NDcxOTY4MDAsImV4cCI6MTc0NzIwMDQwMH0.w1V7_9w9r7_M4u7F_9w9r7_M4u7F_9w9r7_M4u7F_9w9r7_M4u7F_9w9r7_M4u7F_9w9r7_M4u7F_9w9r7_M4u7F_9w9"}
]

export const SAMPLE_SPEC = `openapi: 3.0.3
info:
  title: Sample User Management API
  description: A sample API built using OpenAPI 3.0 to manage application users.
  version: 1.0.0
servers:
  - url: https://api.example.com/v1
    description: Production server
  - url: http://localhost:8080/v1
    description: Local development server
paths:
  /users:
    get:
      summary: Get all users
      description: Returns a list of all registered users in the system.
      operationId: getUsers
      responses:
        '200':
          description: A successful response containing the user list.
          content:
            application/json:
              schema:
                type: array
                items:
                  $ref: '#/components/schemas/User'
        '500':
          description: Internal server error.
    post:
      summary: Create a new user
      description: Registers a new user into the database.
      operationId: createUser
      requestBody:
        description: User object to be added
        required: true
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/User'
      responses:
        '201':
          description: User created successfully.
          content:
            application/json:
              schema:
                $ref: '#/components/schemas/User'
        '400':
          description: Invalid request payload.
  /users/{id}:
    put:
      summary: Update user
      description: Updates an existing user's details.
      operationId: updateUser
      parameters:
        - name: id
          in: path
          required: true
          description: User identifier
          schema:
            type: integer
      requestBody:
        required: true
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/User'
      responses:
        '201':
          description: Updated
components:
  schemas:
    User:
      type: object
      properties:
        id:
          type: integer
          format: int64
          example: 101
        name:
          type: string
          example: Jane Doe
        email:
          type: string
          format: email
          example: janedoe@example.com
        status:
          type: string
          enum: [active, inactive]
          example: active
`;
